<template>
  <article id="mainPage" class="main-page">
    <section
      :class="[
        { 'on-enter': enter_section_main_view },
        'section-content main-page__main-view',
      ]"
      id="sectionStartView"
    >
      <canvas id="canvas"> </canvas>
      <div class="main-page__main-view__content">
        <div class="man">
          <img src="~@/assets/images/sit_man.png" alt="" />
        </div>
        <div class="left-content">
          <h4 class="fz-32-vw fz-mbl-28 fz-mbp-20">
            JOIN AS GUGOBET PARTNER
          </h4>

          <h2 class="slogan-1 fz-65-vw fz-mbl-56 fz-mbp-35">
            MAKE YOUR
          </h2>
          <h2 class="slogan-2 fz-65-vw fz-mbl-56 fz-mbp-35">
            DREAM COME TRUE !
          </h2>
          <div class="man-mobile">
            <img src="~@/assets/images/sit_man.png" alt="" />
          </div>
          <div class="four-features">
            <div
              :class="[
                { 'on-enter': enter_section_main_view },
                'four-features__feature powerful-dashboard',
              ]"
            >
              <img
                src="~@/assets/images/fore_feature_1.png"
                class="icon"
                alt=""
              />
              <p class="feature-text fz-22-vw fz-mbl-20 fz-mbp-16">
                Powerful Dashboard
              </p>
            </div>
            <div
              :class="[
                { 'on-enter': enter_section_main_view },
                'four-features__feature weekly-settle-cycle',
              ]"
            >
              <img
                src="~@/assets/images/fore_feature_2.png"
                class="icon"
                alt=""
              />
              <p class=" feature-text fz-22-vw fz-mbl-20 fz-mbp-16">
                Weekly Settle Cycle
              </p>
            </div>
            <div
              :class="[
                { 'on-enter': enter_section_main_view },
                'four-features__feature brand-loyalty',
              ]"
            >
              <img
                src="~@/assets/images/fore_feature_3.png"
                class="icon"
                alt=""
              />
              <p class=" feature-text fz-22-vw fz-mbl-20 fz-mbp-16">
                Brand Loyalty
              </p>
            </div>
            <div
              :class="[
                { 'on-enter': enter_section_main_view },
                'four-features__feature advertising-support',
              ]"
            >
              <img
                src="~@/assets/images/fore_feature_4.png"
                class="icon"
                alt=""
              />
              <p class=" feature-text fz-22-vw fz-mbl-20 fz-mbp-16">
                Advertising Support
              </p>
            </div>
          </div>
          <div class="three-entrance">
            <div
              :class="[
                { 'on-enter': enter_section_main_view },
                'three-entrance__entrance web',
              ]"
              v-scroll-to="{
                el: '#sectionBecomeGUGOBETsPartner',
                duration: 900,
                easing: 'ease-in-out',
              }"
            >
              <div class="three-entrance__entrance-content">
                <img
                  src="~@/assets/images/web_link.png"
                  alt=""
                  class="entrance-icon"
                />
                <img
                  src="~@/assets/images/logo-dark.svg"
                  alt=""
                  class="entrance-logo"
                />
              </div>
            </div>
            <div
              :class="[
                { 'on-enter': enter_section_main_view },
                'three-entrance__entrance program-detail',
              ]"
              v-scroll-to="{
                el: '#sectionPowerfulDashboard',
                duration: 900,
                easing: 'ease-in-out',
              }"
            >
              <div class="three-entrance__entrance-content">
                <img
                  src="~@/assets/images/download_pdf.png"
                  alt="Program Detail"
                  class="entrance-icon"
                />
                <p class="entrance-title fz-22-vw fz-mbl-20 fz-mbp-16">
                  Program Detail
                </p>
              </div>
            </div>
            <div
              :class="[
                { 'on-enter': enter_section_main_view },
                'three-entrance__entrance join-us',
              ]"
              v-scroll-to="{
                el: '#sectionBecomeGUGOBETsPartner',
                duration: 900,
                easing: 'ease-in-out',
              }"
            >
              <div class="three-entrance__entrance-content">
                <img
                  src="~@/assets/images/air_plan.png"
                  alt=""
                  class="entrance-icon"
                />
                <p class="entrance-title fz-22-vw fz-mbl-20 fz-mbp-16">
                  Apply Now
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="section-content main-page__our-advantage"
      id="sectionOurAdvantage"
    >
      <h2
        :class="[
          { 'on-enter': enter_section_our_advantage },
          'section-title fz-40-vw fz-mbl-32 fz-mbp-28',
        ]"
      >
        Our Advantage
      </h2>
      <p
        :class="[
          { 'on-enter': enter_section_our_advantage },
          'des fz-16-vw fz-mbl-15',
        ]"
      >
        GUGOBET is one of the biggest global website, founded in UK since 2006.
      </p>
      <div class="phone-and-poker-features">
        <img
          src="~@/assets/images/poker-bg.png"
          alt="GUGOBET is one of the biggest global website, founded in
        UK since 2006."
          :class="[{ 'on-enter': enter_section_our_advantage }, 'poker']"
        />
        <img
          src="~@/assets/images/phone.png"
          :class="[{ 'on-enter': enter_section_our_advantage }, 'phone']"
          alt="GUGOBET is one of the biggest global website, founded in
        UK since 2006."
        />
        <div :class="[{ 'on-enter': enter_section_our_advantage }, 'features']">
          <div class="vip-level feature-content">
            <img
              src="~@/assets/images/vip-level.png"
              class="icon"
              alt="VIP level"
            />
            <p class="text fz-18-vw fz-mbl-14">
              VIP level
            </p>
          </div>
          <div class="lucky-roulette feature-content">
            <img
              src="~@/assets/images/roulette.png"
              class="icon"
              alt="Lucky Roulette"
            />
            <p class="text fz-18-vw fz-mbl-14">
              Lucky Roulette
            </p>
          </div>
          <div class="limit-mission feature-content">
            <img
              src="~@/assets/images/missions.png"
              class="icon"
              alt="Limit Mission"
            />
            <p class="text fz-18-vw fz-mbl-14">
              Limit Mission
            </p>
          </div>
          <div class="fast-deposit-and-withdraw feature-content">
            <img
              src="~@/assets/images/money.png"
              class="icon"
              alt="Fast Finance System"
            />
            <p class="text fz-18-vw fz-mbl-14">
              Fast Finance System
            </p>
          </div>
          <div class="tons-of-games feature-content">
            <img
              src="~@/assets/images/game.png"
              class="icon"
              alt="Tons of Games"
            />
            <p class="text fz-18-vw fz-mbl-14">
              Tons of Games
            </p>
          </div>
        </div>
      </div>
    </section>
    <section
      class="section-content main-page__easy-to-join-easy-get-profit"
      id="sectionJoinProfit"
    >
      <div class="situation-content">
        <h2
          :class="[
            { 'on-enter': enter_easy_to_join_easy_get_profit },
            'section-title fz-40-vw fz-mbl-32 fz-mbp-28',
          ]"
        >
          Easy To Join, Easy To Get Profit!
        </h2>
        <div
          :class="[{ 'on-enter': enter_easy_to_join_easy_get_profit }, 'left']"
        >
          <div class="feature">
            <img
              class="icon"
              src="~@/assets/images/grow.png"
              alt="20%-50% of Profit Share as Commission"
            />
            <p class="text fz-22-vw fz-mbl-18">
              <span class="fz-26-vw fz-mbl-22">20%-50%</span> of Profit<br />Share
              as Commission
            </p>
          </div>
        </div>
        <div
          :class="[{ 'on-enter': enter_easy_to_join_easy_get_profit }, 'right']"
        >
          <div class="feature">
            <img
              class="icon"
              src="~@/assets/images/coin-phone.png"
              alt="5% of Amoun as a Commission"
            />
            <p class="text fz-22-vw fz-mbl-18">
              <span class="fz-26-vw fz-mbl-22">5%</span> of Amount<br />as
              Commission
            </p>
          </div>
        </div>
      </div>
    </section>
    <section
      class="section-content main-page__our-partners-success-stories"
      id="sectionSuccessStories"
    >
      <h2
        :class="[
          { 'on-enter': enter_our_partners_success_stories },
          'section-title fz-40-vw fz-mbl-32 fz-mbp-28',
        ]"
      >
        Our Partners’ Success Stories
      </h2>
      <div class="stories-content">
        <div
          :class="[
            { 'on-enter': enter_our_partners_success_stories_left },
            'stories-content__left',
          ]"
          id="storiesContentLeft"
        >
          <div class="info">
            <div class="info__photo">
              <div class="info__photo__frame">
                <img
                  class="main-photo"
                  src="~@/assets/images/mugshot.png"
                  alt="Our Partners’s"
                />
              </div>
            </div>
            <div class="info__content">
              <ul class="info__content__detail">
                <li class="partner">
                  <div class="partner__header fz-18-vw fz-mbl-16">
                    Partner : <span class="content">Rohit Sharma</span>
                  </div>
                </li>
                <li class="country">
                  <div class="country__header fz-18-vw fz-mbl-16">
                    Country : <span class="content">India, Mumbai</span>
                  </div>
                </li>
                <li class="description fz-20-vw fz-mbl-18">
                  Started working in March, 2021
                </li>
                <li class="description fz-20-vw fz-mbl-18">
                  Manages several communities on social media
                </li>
              </ul>
            </div>
          </div>
          <div class="average">
            <p class="average-commission fz-20-vw fz-mbl-19">
              Average Month Commission :
              <br />
              <span class="fz-30-vw fz-mbl-28"
                ><span>{{ formatCommission_1 }}</span> INR</span
              >
            </p>
          </div>
          <div class="chart">
            <div class="chart__outer">
              <div
                :class="[
                  { 'on-enter': enter_our_partners_success_stories_left },
                  'chart__data-players',
                ]"
              >
                <div
                  class="chart__data-players__value"
                  style="height: 5%"
                ></div>
                <div
                  class="chart__data-players__value"
                  style="height: 20%"
                ></div>
                <div
                  class="chart__data-players__value"
                  style="height: 37%"
                ></div>
                <div
                  class="chart__data-players__value"
                  style="height: 48%"
                ></div>
                <div
                  class="chart__data-players__value"
                  style="height: 65%"
                ></div>
                <div
                  class="chart__data-players__value"
                  style="height: 85%"
                ></div>
              </div>
              <div
                :class="[
                  { 'on-enter': enter_our_partners_success_stories },
                  'chart__data-profit',
                ]"
              >
                <div class="chart__data-profit__value" style="height: 1%"></div>
                <div
                  class="chart__data-profit__value"
                  style="height: 12%"
                ></div>
                <div
                  class="chart__data-profit__value"
                  style="height: 19%"
                ></div>
                <div
                  class="chart__data-profit__value"
                  style="height: 26%"
                ></div>
                <div
                  class="chart__data-profit__value"
                  style="height: 32%"
                ></div>
                <div
                  class="chart__data-profit__value"
                  style="height: 40%"
                ></div>
              </div>
            </div>
            <div class="chart__months-list">
              <p class="month fz-20">Mar</p>
              <p class="month fz-20">Apr</p>
              <p class="month fz-20">Jun</p>
              <p class="month fz-20">Jul</p>
              <p class="month fz-20">Aug</p>
              <p class="month fz-20">Sep</p>
            </div>
            <div class="chart__comment">
              <div class="chart__comment__players">
                <div class="players-box"></div>
                <div class="players-text">Players</div>
              </div>
              <div class="chart__comment__profit">
                <div class="profit-box"></div>
                <div class="profit-text">Profit, ₹</div>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="[
            { 'on-enter': enter_our_partners_success_stories_right },
            'stories-content__right',
          ]"
          id="storiesContentRight"
        >
          <div class="info">
            <div class="info__photo">
              <div class="info__photo__frame">
                <img
                  class="main-photo"
                  src="~@/assets/images/mugshot-2.png"
                  alt="Our Partners’s"
                />
              </div>
            </div>
            <div class="info__content">
              <ul class="info__content__detail">
                <li class="partner">
                  <div class="partner__header fz-18-vw fz-mbl-16">
                    Partner : <span class="content">Varun Reddy</span>
                  </div>
                </li>
                <li class="country">
                  <div class="country__header fz-18-vw fz-mbl-16">
                    Country : <span class="content">India, Hyderabad</span>
                  </div>
                </li>
                <li class="description fz-20-vw fz-mbl-18">
                  Started working in April, 2021
                </li>
                <li class="description fz-20-vw fz-mbl-18">
                  Website owner
                </li>
              </ul>
            </div>
          </div>
          <div class="average">
            <p class="average-commission fz-20-vw fz-mbl-19">
              Average Month Commission :
              <br />
              <span class="fz-30-vw fz-mbl-28"
                ><span>{{ formatCommission_2 }}</span> INR</span
              >
            </p>
          </div>
          <div class="chart">
            <div class="chart__outer">
              <div
                :class="[
                  { 'on-enter': enter_our_partners_success_stories_right },
                  'chart__data-players',
                ]"
              >
                <div
                  class="chart__data-players__value"
                  style="height: 4%"
                ></div>
                <div
                  class="chart__data-players__value"
                  style="height: 18%"
                ></div>
                <div
                  class="chart__data-players__value"
                  style="height: 30%"
                ></div>
                <div
                  class="chart__data-players__value"
                  style="height: 38%"
                ></div>
                <div
                  class="chart__data-players__value"
                  style="height: 40%"
                ></div>
              </div>
              <div
                :class="[
                  { 'on-enter': enter_our_partners_success_stories },
                  'chart__data-profit',
                ]"
              >
                <div class="chart__data-profit__value" style="height: 1%"></div>
                <div class="chart__data-profit__value" style="height: 5%"></div>
                <div
                  class="chart__data-profit__value"
                  style="height: 11%"
                ></div>
                <div
                  class="chart__data-profit__value"
                  style="height: 13%"
                ></div>
                <div
                  class="chart__data-profit__value"
                  style="height: 20%"
                ></div>
              </div>
            </div>
            <div class="chart__months-list">
              <p class="month fz-20">Apr</p>
              <p class="month fz-20">Jun</p>
              <p class="month fz-20">Jul</p>
              <p class="month fz-20">Aug</p>
              <p class="month fz-20">Sep</p>
            </div>
            <div class="chart__comment">
              <div class="chart__comment__players">
                <div class="players-box"></div>
                <div class="players-text">Players</div>
              </div>
              <div class="chart__comment__profit">
                <div class="profit-box"></div>
                <div class="profit-text">Profit, ₹</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="section-content main-page__advantage-for-agency"
      id="sectionAdvantageForAgency"
    >
      <h2
        :class="[
          { 'on-enter': enter_advantage_for_agency },
          'section-title fz-40-vw fz-mbl-32 fz-mbp-28',
        ]"
        id="sectionPowerfulDashboard"
      >
        GUGOBET’s Advantage for Agency
      </h2>
      <article class="main-page__advantage-for-agency__content">
        <section
          :class="[
            { 'on-enter': enter_advantage_for_agency },
            'content-section powerful-dashboard',
          ]"
        >
          <div class="content-section__pattern">
            <img
              src="~@/assets/images/powerful_dashboard.png"
              alt="Powerful Dashboard"
            />
          </div>
          <div class="content-section__text">
            <h3 class="fz-35-vw fz-mbl-30 fz-mbp-26">Powerful Dashboard</h3>
            <p class="fz-20-vw fz-mbl-18">
              We provide partners with a powerful dashboard. Through it, you can
              monitor your business in real time. View complete member
              information, interaction record, account change records, game
              records. The system automatically settles commissions based on
              this information.
            </p>
          </div>
        </section>
        <section
          :class="[
            { 'on-enter': enter_advantage_for_agency },
            'content-section weekly-settle-cycle swap',
          ]"
        >
          <div class="content-section__pattern">
            <img
              src="~@/assets/images/weekly_settle.png"
              alt="Weekly Settle Cycle"
            />
          </div>
          <div class="content-section__text">
            <h3 class="fz-35-vw fz-mbl-30 fz-mbp-26">Weekly Settle Cycle</h3>
            <p class="fz-20-vw fz-mbl-18">
              The salary is settled once a week. GUGOBET marketing manager will
              settle last week’s salary before every Friday based on the data on
              the agent’s dashboard.
            </p>
          </div>
        </section>
        <section
          :class="[
            { 'on-enter': enter_advantage_for_agency },
            'content-section advertising-support',
          ]"
        >
          <div class="content-section__pattern">
            <img
              src="~@/assets/images/advertising_support.png"
              alt="Advertising Support"
            />
          </div>
          <div class="content-section__text">
            <h3 class="fz-35-vw fz-mbl-30 fz-mbp-26">Advertising Support</h3>
            <p class="fz-20-vw fz-mbl-18">
              GUGOBET will provide a large number of advertising materials to
              assist agencies to promote GUGOBET’s products.
            </p>
          </div>
        </section>
        <section
          :class="[
            { 'on-enter': enter_advantage_for_agency },
            'content-section brand-loyalty swap',
          ]"
        >
          <div class="content-section__text full-width">
            <h3 class="fz-35-vw fz-mbl-30 fz-mbp-26">Brand Loyalty</h3>
            <p class="fz-20-vw fz-mbl-18">
              Marketing manager 1V1 service agents, assist agents to develop
              their own team advertisement.
            </p>
          </div>
        </section>
      </article>
    </section>
    <section class="section-content main-page__big-money" id="sectionBigMoney">
      <div
        :class="[
          { 'on-enter': enter_big_money },
          'main-page__big-money__blue-bg',
        ]"
      ></div>
      <div
        :class="[{ 'on-enter': enter_big_money }, 'main-page__big-money__man']"
      >
        <img
          src="~@/assets/images/big-money.png"
          alt="JOIN GUGOBET TO FULFILL YOUR DREAM."
        />
      </div>
      <p
        :class="[
          { 'on-enter': enter_big_money },
          'main-page__big-money__slogan fz-45-vw fz-mbl-40 fz-mbp-30',
        ]"
      >
        JOIN GUGOBET TO FULFILL YOUR DREAM.
      </p>
    </section>
    <section
      class="section-content main-page__become-GUGOBETs-partner"
      id="sectionBecomeGUGOBETsPartner"
    >
      <h2
        :class="[
          { 'on-enter': enter_become_GUGOBETs_partner },
          'section-title fz-40-vw fz-mbl-32 fz-mbp-28',
        ]"
      >
        I Want to Become GUGOBET’s Partner
      </h2>
      <h3
        :class="[
          { 'on-enter': enter_become_GUGOBETs_partner },
          'sub-title fz-26-vw fz-mbl-22 fz-mbp-20',
        ]"
      >
        Contact us through options below.
      </h3>
      <div class="main-page__become-GUGOBETs-partner__main-content">
        <a
          v-if="contactLinkSetting.whatsApp"
          :href="contactLinkSetting.whatsApp.link"
          :class="[{ 'on-enter-1': enter_become_GUGOBETs_partner }, 'telegram']"
          :title="contactLinkSetting.whatsApp.title"
          target="_blank"
          :style="{
            'pointer-events': contactLinkSetting.whatsApp.link
              ? 'initial'
              : 'none',
          }"
        >
          <img class="contact-link-icon" src="~@/assets/images/whats-app.svg" />
          <p class="text fz-20-vw fz-mbl-18">WhatsApp</p>
        </a>
        <a
          v-if="contactLinkSetting.telegram"
          :href="contactLinkSetting.telegram.link"
          :class="[{ 'on-enter-2': enter_become_GUGOBETs_partner }, 'telegram']"
          :title="contactLinkSetting.telegram.title"
          target="_blank"
          :style="{
            'pointer-events': contactLinkSetting.telegram.link
              ? 'initial'
              : 'none',
          }"
        >
          <img
            class="contact-link-icon contact-link-icon--telegram"
            src="~@/assets/images/telegram.svg"
          />
          <p class="text fz-20-vw fz-mbl-18">Telegram</p>
        </a>
      </div>
    </section>
  </article>
</template>

<script>
// *mobile-detect
import MobileDetect from "../../node_modules/mobile-detect/mobile-detect.min.js";

// *ScrollMagic
import ScrollMagic from "scrollmagic";
import { gsap } from "gsap";

export default {
  name: "Home",

  data() {
    return {
      commission_1_value: { value: 10000 },
      commission_2_value: { value: 10000 },
      isMobile: undefined,
      enter_section_main_view: false,
      enter_section_our_advantage: false,
      enter_easy_to_join_easy_get_profit: false,
      enter_our_partners_success_stories: false,
      enter_our_partners_success_stories_left: false,
      enter_our_partners_success_stories_right: false,
      enter_advantage_for_agency: false,
      enter_big_money: false,
      enter_become_GUGOBETs_partner: false,
      contactLink: {
        // Group 1
        "thefreelance.agency": {
          whatsApp: {
            link: "https://wa.me/message/RRW7LOVMEY6OK1",
            title: "Contact us through WhatsApp.",
          },
          telegram: {
            link: "https://t.me/gugobetagent",
            title: "Contact our Telegram. @kamall8588",
          },
        },
        "online-job.work": {
          whatsApp: {
            // link: "https://wa.me/message/RRW7LOVMEY6OK1",
            link: "",
            title: "Contact us through WhatsApp.",
          },
          telegram: {
            // link: "https://t.me/gugobetagent",
            link: "",
            title: "Contact our Telegram. @kamall8588",
          },
        },
        "alltimefreelance.info": {
          whatsApp: {
            link: "https://wa.me/message/QGRBPHYDMFKNI1",
            title: "Contact us through WhatsApp.",
          },
          telegram: {
            link: "https://t.me/gugobetagent",
            title: "Contact our Telegram. @kamall8588",
          },
        },
        "beagentnow.online": {
          whatsApp: {
            link: "https://wa.me/message/GXLDXXWTZNXSN1",
            title: "Contact us through WhatsApp.",
          },
          telegram: {
            link: "http://t.me/gugobetagent2",
            title: "Contact our Telegram. @kamall8588",
          },
        },
        "alltimemember.com": {
          whatsApp: {
            // link: "https://wa.me/message/RRW7LOVMEY6OK1",
            link: "",
            title: "Contact us through WhatsApp.",
          },
          telegram: {
            // link: "https://t.me/gugobetagent",
            link: "",
            title: "Contact our Telegram. @kamall8588",
          },
        },

        // Group 2
        "freepartner.online": {
          whatsApp: {
            link:
              "https://wa.me/886965720939?text=I%27m%20interested%20in%20earn%20money%20with%20gugobet",
            title: "Contact us through WhatsApp.",
          },
          telegram: {
            link: "https://t.me/gugobetagent",
            title: "Contact our Telegram. @Devaraj_banda",
          },
        },
      },
    };
  },

  computed: {
    formatCommission_1() {
      let commission = Math.round(this.commission_1_value.value);
      return this.numberWithCommas(commission);
    },
    formatCommission_2() {
      let commission = Math.round(this.commission_2_value.value);
      return this.numberWithCommas(commission);
    },
    contactLinkSetting() {
      const defaultSetting = {
        whatsApp: {
          link: "https://wa.me/94774635138",
          title: "Contact us through WhatsApp.",
        },
        telegram: {
          link: "https://t.me/gugopartner",
          title: "Contact our Telegram. @gugopartner",
        },
      };
      const { hostname } = window.location;
      let currentLinkSetting;
      
      Object.keys(this.contactLink).find((domain) => {
        if (hostname.includes(domain.trim())) {
          currentLinkSetting = this.contactLink[domain];
          return true;
        }
        return false;
      });

      return currentLinkSetting || defaultSetting;
    },
  },

  mounted() {
    // #是否為行動裝置
    this.isMobile = new MobileDetect(window.navigator.userAgent).mobile();
    this.initScrollMagic();
    testRun();
  },

  methods: {
    initScrollMagic() {
      // #ScrollMagic 初始化
      const scrollMagicController = new ScrollMagic.Controller();

      const ourAdvantageScene = new ScrollMagic.Scene({
        triggerElement: "#sectionOurAdvantage",
        triggerHook: this.isMobile ? 0.5 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      ourAdvantageScene.on("enter", () => {
        this.enter_section_our_advantage = true;
      });

      const joinProfitScene = new ScrollMagic.Scene({
        triggerElement: "#sectionJoinProfit",
        triggerHook: this.isMobile ? 0.5 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      joinProfitScene.on("enter", () => {
        this.enter_easy_to_join_easy_get_profit = true;
      });

      const successStoriesScene = new ScrollMagic.Scene({
        triggerElement: "#sectionSuccessStories",
        triggerHook: this.isMobile ? 0.5 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      successStoriesScene.on("enter", () => {
        this.enter_our_partners_success_stories = true;
      });

      const successStoriesLeft = new ScrollMagic.Scene({
        triggerElement: "#storiesContentLeft",
        triggerHook: this.isMobile ? 0.8 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      successStoriesLeft.on("enter", () => {
        this.enter_our_partners_success_stories_left = true;
        this.NumberCounter_1();
      });

      const successStoriesRight = new ScrollMagic.Scene({
        triggerElement: "#storiesContentRight",
        triggerHook: this.isMobile ? 0.8 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      successStoriesRight.on("enter", () => {
        this.enter_our_partners_success_stories_right = true;
        this.NumberCounter_2();
      });

      const advantageForAgency = new ScrollMagic.Scene({
        triggerElement: "#sectionAdvantageForAgency",
        triggerHook: this.isMobile ? 0.5 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      advantageForAgency.on("enter", () => {
        this.enter_advantage_for_agency = true;
      });

      const bigMoney = new ScrollMagic.Scene({
        triggerElement: "#sectionBigMoney",
        triggerHook: this.isMobile ? 0.5 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      bigMoney.on("enter", () => {
        this.enter_big_money = true;
      });

      const becomeGUGOBETsPartner = new ScrollMagic.Scene({
        triggerElement: "#sectionBecomeGUGOBETsPartner",
        triggerHook: this.isMobile ? 1 : 0.6,
        duration: "100%",
      }).addTo(scrollMagicController);

      becomeGUGOBETsPartner.on("enter", () => {
        this.enter_become_GUGOBETs_partner = true;
      });

      this.enter_section_main_view = true;
    },
    NumberCounter_1() {
      gsap.to(this.commission_1_value, {
        value: 450000,
        duration: 3,
        ease: "power1.in",
      });
    },
    NumberCounter_2() {
      gsap.to(this.commission_2_value, {
        value: 120000,
        duration: 3,
        ease: "power1.in",
      });
    },
    numberWithCommas(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};

//粒子運動

function testRun() {
  new Visual();
}
function random(low, high) {
  return Math.random() * (high - low) + low;
}

class Visual {
  constructor() {
    this.isMobile = new MobileDetect(window.navigator.userAgent).mobile();
    this.canvas = document.querySelector("#canvas");
    this.context = this.canvas.getContext("2d");
    this.canvasWidth = 0;
    this.canvasHeight = 0;
    this.particleLength = this.isMobile ? 30 : 70;
    this.particles = [];
    this.particleMaxRadius = 8;

    this.handleMouseMoveBind = this.handleMouseMove.bind(this);
    this.handleClickBind = this.handleClick.bind(this);
    this.handleResizeBind = this.handleResize.bind(this);

    this.initialize();
    this.render();
  }

  initialize() {
    this.resizeCanvas();
    for (let i = 0; i < this.particleLength; i++) {
      this.particles.push(this.createParticle(i));
    }
    this.bind();
  }

  bind() {
    document.body.addEventListener(
      "mousemove",
      this.handleMouseMoveBind,
      false
    );
    // document.body.addEventListener('click', this.handleClickBind, false);
    window.addEventListener("resize", this.handleResizeBind, false);
  }

  unbind() {
    document.body.removeEventListener(
      "mousemove",
      this.handleMouseMoveBind,
      false
    );
    document.body.removeEventListener("click", this.handleClickBind, false);
    window.removeEventListener("resize", this.handleResizeBind, false);
  }

  handleMouseMove(e) {
    this.enlargeParticle(e.clientX, e.clientY);
  }

  handleClick(e) {
    this.burstParticle(e.clientX, e.clientY);
  }

  handleResize() {
    this.resizeCanvas();
  }

  resizeCanvas() {
    this.canvasWidth = document.getElementById("sectionStartView").offsetWidth;
    this.canvasHeight = document.getElementById(
      "sectionStartView"
    ).offsetHeight;
    this.canvas.width = this.canvasWidth * window.devicePixelRatio;
    this.canvas.height = this.canvasHeight * window.devicePixelRatio;
    this.context = this.canvas.getContext("2d");
    this.context.scale(window.devicePixelRatio, window.devicePixelRatio);
  }

  createParticle(id, isRecreate) {
    const radius = random(1, this.particleMaxRadius);
    const x = isRecreate
      ? -radius - random(0, this.canvasWidth)
      : random(0, this.canvasWidth);
    let y = random(this.canvasHeight / 2 - 150, this.canvasHeight / 2 + 150);
    y += random(-100, 100);
    const alpha = random(0.05, 0.3);

    return {
      id: id,
      x: x,
      y: y,
      startY: y,
      radius: radius,
      defaultRadius: radius,
      startAngle: 0,
      endAngle: Math.PI * 2,
      alpha: alpha,
      color: { r: 255, g: random(250, 255), b: random(175, 255) },
      speed: alpha + 1,
      amplitude: random(0, 200),
      isBurst: false,
    };
  }

  drawParticles() {
    this.particles.forEach((particle) => {
      // 位置情報更新
      this.moveParticle(particle);

      // particle描画
      this.context.beginPath();
      this.context.fillStyle = `rgba(${particle.color.r}, ${particle.color.g}, ${particle.color.b}, ${particle.alpha})`;
      this.context.arc(
        particle.x,
        particle.y,
        particle.radius,
        particle.startAngle,
        particle.endAngle
      );
      this.context.fill();
    });
  }

  moveParticle(particle) {
    particle.x += particle.speed;
    particle.y =
      particle.startY +
      particle.amplitude * Math.sin(((particle.x / 5) * Math.PI) / 180);
  }

  enlargeParticle(clientX, clientY) {
    this.particles.forEach((particle) => {
      if (particle.isBurst) return;

      const distance = Math.hypot(particle.x - clientX, particle.y - clientY);

      if (distance <= 100) {
        const scaling = (100 - distance) / 1.5;
        gsap.to(particle, {
          radius: particle.defaultRadius + scaling,
          duration: 0.5,
          ease: "power2.out",
        });
      } else {
        gsap.to(particle, {
          radius: particle.defaultRadius,
          duration: 0.5,
          ease: "power2.out",
        });
      }
    });
  }

  burstParticle(clientX, clientY) {
    this.particles.forEach((particle) => {
      const distance = Math.hypot(particle.x - clientX, particle.y - clientY);

      if (distance <= 100) {
        particle.isBurst = true;
        gsap.to(particle, {
          radius: particle.defaultRadius + 200,
          alpha: 0,
          duration: 0.5,
          ease: "power2.out",
          onComplete: () => {
            this.particles[particle.id] = this.createParticle(
              particle.id,
              true
            );
          },
        });
      }
    });
  }

  render() {
    // canvas初期化
    this.context.clearRect(
      0,
      0,
      this.canvasWidth + this.particleMaxRadius * 2,
      this.canvasHeight
    );

    // particleを描画
    this.drawParticles();

    // 画面から消えたら新しいparticleに差し替え
    this.particles.forEach((particle) => {
      if (particle.x - particle.radius >= this.canvasWidth) {
        this.particles[particle.id] = this.createParticle(particle.id, true);
      }
    });

    requestAnimationFrame(this.render.bind(this));
  }
}
</script>
